import React from "react"
import PropTypes from "prop-types"

const Quote = ({ text, author }) => (
  <blockquote className="p-4 italic border-l-4 bg-neutral-100 text-neutral-600 border-neutral-500 quote">
    <span className="text-lg leading-loose">{`"${text}"`}</span>
    <br />
    <span className="text-sm leading-none block text-right">- {author}</span>
  </blockquote>
)

Quote.propTypes = {
  text: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
}

export default Quote
